<div class="calc-width po-component-container">
  <div class="po-header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="d-flex flex-wrap gap-2 align-items-center">
      <div class="d-flex my-auto">
        <button nz-button nzType="primary" nzDanger (click)="onCancelOrder()">Cancel Order</button>
      </div>
      <div class="my-auto">
        Section : {{ orderDetails.sectionName }}
      </div>
      <div class="d-flex my-auto">
        <div>
          Table :
          <nz-select nzMode="multiple" nzPlaceHolder="Select Table" [(ngModel)]="orderDetails.tables"
            class="table-select" [nzAllowClear]="false" (ngModelChange)="onTableChange($event)">
            @for (table of availableTables; track table) {
              <nz-option [nzLabel]="table.name" [nzValue]="table.id"></nz-option>
            }
          </nz-select>
        </div>
      </div>
      <div class="d-flex my-auto">
        <div class="keyboard-trigger"
          nz-tooltip="Click to view all keyboard shortcuts"
          (click)="showKeyboardShortcuts()">
          <em class="las la-keyboard"></em>
        </div>
      </div>
    </div>
    <div (click)="toggleOrderCart()" class="click-behaviour d-flex cursor align-items-center" [matTooltip]="getCartTooltip()">
      <p class="text-weight me-3 fs-5 my-auto">{{foodCount}}</p>
      <em class="las la-shopping-cart cart-icon"></em>
    </div>
  </div>
  <div class="row mt-2 g-0" [ngClass]="{'mx-2': isTabletView || !desktopCartVisible}">
    <div [ngClass]="{'col-8 pe-4': !isTabletView && desktopCartVisible, 'col-12': isTabletView || !desktopCartVisible}">
      <lib-order-menu [sectionId]="sectionId" [orderDetails]="orderDetails" [tables]="tables"></lib-order-menu>
    </div>
    <!-- Cart Section - ONLY visible on desktop when desktopCartVisible is true -->
    @if (!isTabletView && desktopCartVisible) {
      <div class="col-4">
        <lib-order-cart (orderPrinted)="onNotPrinted($event)" [tables]="tables" [orderDetails]="orderDetails"
          [orderId]="orderId" (foodSubmitted)="onFoodSubmitted($event)"
        (orderDetailsUpdated)="onOrderDetailsUpdated($event)"></lib-order-cart>
      </div>
    }
  </div>
</div>
